import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import 'react-tabs/style/react-tabs.css';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import VideoUpload from '../VideoUpload/VideoUpload';
import materialTheme from '../../reactMaterialTheme';
import Wysiwyg from '../../shared/Wysiwyg';
import { useCreativeInput } from '../../hooks';
import { PartnerProvider } from '../../partners/partner';
import './InstreamVideoBuilder.scss';

export const InstreamVideoBuilder = props => {
  return (
    <PartnerProvider>
      <InstreamVideoForm {...props} />
    </PartnerProvider>
  );
};

// Can be renamed to InstreamVideoBuilder once PartnerProvider is placed upstream
const InstreamVideoForm = props => {
  const [creative, setCreative] = useState({ ...props.creative });

  const creativeInputProps = useCreativeInput(
    [
      'name',
      'customEngagementUrl',
      'isiAutoscroll',
      'isiText',
    ],
    creative,
    setCreative,
    props.CreativeService
  );

  const handleFocus = event => event.target.select();

  return (
    <MuiThemeProvider theme={materialTheme}>
      <form className="p2 native-outstream-builder">
        <div className="row">
          <TextField
            {...creativeInputProps.nameProps}
            label="Ad Name"
            className="col-xs-10"
            name="name"
            inputProps={{ 'data-testid': 'creative-name-input' }}
            onFocus={handleFocus}
            required
          />
        </div>
        <div className="row mt2">
          <TextField
            {...creativeInputProps.customEngagementUrlProps}
            label="Clickout URL"
            className="col-xs-10"
            inputProps={{
              'data-testid': 'creative-custom-engagement-url-input'
            }}
            onFocus={handleFocus}
          />
        </div>
        <div className="row mt2">
          <strong>Upload MP4 Video</strong>
          <VideoUpload
            SaveCreativeService={props.SaveCreativeService}
            CreativeService={props.CreativeService}
          />
        </div>
        {creative.isiText === null || creative.isiText === undefined ? null : (
          <div className="row mt3">
            <div className="form-group inline">
              <h3 className="inline m0 vertical-align-middle">
                Important Safety Information
              </h3>
              <div className="vertical-align-middle pull-right">
                <FormControlLabel
                  control={
                    <Checkbox
                      name="isiAutoscroll"
                      checked={creativeInputProps.isiAutoscrollProps.value}
                      onChange={creativeInputProps.isiAutoscrollProps.onChange}
                    />
                  }
                  label="Enable Auto-Scrolling"
                />
              </div>
              <Wysiwyg
                placeholder="Write your important safety information message"
                value={creative.isiText}
                onChange={creativeInputProps.isiTextProps.onChange}
              />
            </div>
          </div>
        )}
      </form>
    </MuiThemeProvider>
  );
};

InstreamVideoBuilder.propTypes = {
  creative: PropTypes.shape({}).isRequired,
  CreativeService: PropTypes.shape({
    set: PropTypes.func.isRequired
  }).isRequired,
  SaveCreativeService: PropTypes.shape({
    save: PropTypes.func.isRequired
  }).isRequired,
  $modal: PropTypes.object.isRequired,
  $rootScope: PropTypes.object.isRequired,
};

InstreamVideoForm.propTypes = InstreamVideoBuilder.propTypes;
